import React, { Component } from 'react'
import AutoInput from '../containers/AutoInput'
import withValues from '../hocs/withValues'
import { getValue } from '../utils/models'
import { Icon, Tabs } from 'antd'
import custom from "../config/custom";
import { Button } from "antd";
import { FormattedMessage } from 'react-intl';
import List from "../containers/List";

import '../containers/Quote/index.css'

const { TabPane } = Tabs;

class ArrivalNotificationEdit extends Component {

  constructor(props) {
    super(props)

    this.state = {
      customer: getValue(this.props.values, "customer"),
      customerQuery: null,
      pol: null,
      pod: null,
      vessel: null,
      tmsId: null,
      generatepdf: true,
      shipper: null,
      consignee: null,
      reference: null,
      hbl: null,
      mbl: null,
      goodsdescription: null,
      packages: null,
      weigth: null,
      vol: null,
      etd: null,
      eta: null,
      finaldestination: null,
      voyage: null,
      carrier: null,
      atd: null,
      ata: null,
      modality: null,
      printing: false,
    };
  }

  //Traer los datos al state 
  componentDidUpdate(prevProps) {
    if (this.props.values.pod !== prevProps.values.pod) {
      this.setState({
        pod: getValue(this.props.values, "pod")
      });
    }
    if (this.props.values.pol !== prevProps.values.pol) {
      this.setState({
        pol: getValue(this.props.values, "pol")
      });
    }
    if (this.props.values.tmsId !== prevProps.values.tmsId) {
      this.setState({
        tmsId: getValue(this.props.values, "tmsId")
      });
    }
    if (this.props.values.vessel !== prevProps.values.vessel) {
      this.setState({
        vessel: getValue(this.props.values, "vessel")
      });
    }
    if (this.props.values.shipper !== prevProps.values.shipper) {
      this.setState({
        shipper: getValue(this.props.values, "shipper")
      });
    }
    if (this.props.values.consignee !== prevProps.values.consignee) {
      this.setState({
        consignee: getValue(this.props.values, "consignee")
      });
    }
    if (this.props.values.reference !== prevProps.values.reference) {
      this.setState({
        reference: getValue(this.props.values, "reference")
      });
    }
    if (this.props.values.hbl !== prevProps.values.hbl) {
      this.setState({
        hbl: getValue(this.props.values, "hbl")
      });
    }
    if (this.props.values.mbl !== prevProps.values.mbl) {
      this.setState({
        mbl: getValue(this.props.values, "mbl")
      });
    }
    if (this.props.values.goodsdescription !== prevProps.values.goodsdescription) {
      this.setState({
        goodsdescription: getValue(this.props.values, "goodsdescription")
      });
    }
    if (this.props.values.packages !== prevProps.values.packages) {
      this.setState({
        packages: getValue(this.props.values, "packages")
      });
    }
    if (this.props.values.weigth !== prevProps.values.weigth) {
      this.setState({
        weigth: getValue(this.props.values, "weigth")
      });
    }
    if (this.props.values.vol !== prevProps.values.vol) {
      this.setState({
        vol: getValue(this.props.values, "vol")
      });
    }
    if (this.props.values.etd !== prevProps.values.etd) {
      this.setState({
        etd: getValue(this.props.values, "etd")
      });
    }
    if (this.props.values.eta !== prevProps.values.eta) {
      this.setState({
        eta: getValue(this.props.values, "eta")
      });
    }
    if (this.props.values.finaldestination !== prevProps.values.finaldestination) {
      this.setState({
        finaldestination: getValue(this.props.values, "finaldestination")
      });
    }
    if (this.props.values.voyage !== prevProps.values.voyage) {
      this.setState({
        voyage: getValue(this.props.values, "voyage")
      });
    }
    if (this.props.values.carrier !== prevProps.values.carrier) {
      this.setState({
        carrier: getValue(this.props.values, "carrier")
      });
    }
    if (this.props.values.atd !== prevProps.values.atd) {
      this.setState({
        atd: getValue(this.props.values, "atd")
      });
    }
    if (this.props.values.ata !== prevProps.values.ata) {
      this.setState({
        ata: getValue(this.props.values, "ata")
      });
    }
    if (this.props.values.atd !== prevProps.values.atd) {
      this.setState({
        atd: getValue(this.props.values, "atd")
      });
    }
    if (this.props.values.modality !== prevProps.values.modality) {
      this.setState({
        modality: getValue(this.props.values, "modality")
      });
    }
  }

  getCustomerFilter() {
    let customerFilter = {
      or: [
        {
          id: this.state.customer
        }
      ]
    }

    if (this.state.customerQuery) {
      customerFilter.or = [
        ...customerFilter.or,
        {
          active: true,
          name: {
            contains: this.state.customerQuery
          }
        }
      ]
    }

    return customerFilter
  }

  validateState() {
    if (this.state.atd && this.state.carrier && this.state.consignee && this.state.eta && this.state.etd
      && this.state.finaldestination && this.state.goodsdescription && this.state.hbl && this.state.mbl && this.state.packages && this.state.pod
      && this.state.pol && this.state.reference && this.state.shipper && this.state.tmsId && this.state.vessel && this.state.vol && this.state.voyage
      && this.state.weigth && this.state.generatepdf === true) {
      this.setState({ generatepdf: false });
    }
  }
  //send to pdf
  printing() {
    window.open(`${custom.baseUrl}/arrival-pdf/${this.props.values.id}/pdf`)
  }

  render() {

    const belongsToProp = {
      belongsTo: {
        association: "arrivalnotification",
        id: this.props.id,
        date: null,
      }
    };

    return (
      <div>
        <Tabs defaultActiveKey="1">
          <TabPane
            tab={
              <span>
                <Icon type="container" />
                Shippment Details
              </span>
            }
            key="2"
          >
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={'arrivalnotification'}
              id={this.props.id}
              autoSave
              attribute={'shipper'}
              value={this.state.shipper}
              onChange={value => {
                this.setState({ shipper: value });
              }}
            />
            <AutoInput
              form={this.props.form}
              model={"arrivalnotification"}
              attribute={"modality"}
              autoSave
              type={"model"}
              items={["CY/CY", "DOOR/CY", "CY/DOOR", "DOOR/DOOR", "CY/RAMP"]}
              onChange={value => {
                this.setState({ modality: value });
              }}
              value={this.state.modality}
            />
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={'arrivalnotification'}
              id={this.props.id}
              autoSave
              attribute={'consignee'}
              value={this.state.consignee}
              onChange={value => {
                this.setState({ consignee: value });
              }}
            />
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={'arrivalnotification'}
              id={this.props.id}
              autoSave
              attribute={'notify'}
              value={getValue(this.props.values, 'notify')}
            />

            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={'arrivalnotification'}
              id={this.props.id}
              autoSave
              attribute={'availableAt'}
              value={getValue(this.props.values, 'availableAt')}
            />
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={'arrivalnotification'}
              id={this.props.id}
              autoSave
              attribute={'originalsNo'}
              value={getValue(this.props.values, 'originalsNo')}
            />
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={'arrivalnotification'}
              id={this.props.id}
              autoSave
              attribute={'payableBy'}
              value={getValue(this.props.values, 'payableBy')}
            />
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={'arrivalnotification'}
              id={this.props.id}
              autoSave
              attribute={'payableAt'}
              value={getValue(this.props.values, 'payableAt')}
            />
            <div
              className="aproveQuote"
            >
              <Button
                className="aproveQuote"
                onClick={e => {
                  e.stopPropagation()
                  this.printing()
                }}
                disabled={this.state.generatepdf}
                loading={this.state.printing}
                size="medium"
              >
                <Icon type="file-text" />
                Print
              </Button>
            </div>
          </TabPane>
          <TabPane
            tab={
              <span>
                <Icon type="book" />
                Commodity Summary
              </span>
            }
            key="3"
          >
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={'arrivalnotification'}
              id={this.props.id}
              autoSave
              attribute={'reference'}
              value={this.state.reference}
              onChange={value => {
                this.setState({ reference: value });
              }}
            />
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={'arrivalnotification'}
              id={this.props.id}
              autoSave
              attribute={'hbl'}
              value={this.state.hbl}
              onChange={value => {
                this.setState({ hbl: value });
              }}
            />
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={'arrivalnotification'}
              id={this.props.id}
              autoSave
              attribute={'mbl'}
              value={this.state.mbl}
              onChange={value => {
                this.setState({ mbl: value });
              }}
            />
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={'arrivalnotification'}
              id={this.props.id}
              autoSave
              attribute={'goodsdescription'}
              value={this.state.goodsdescription}
              onChange={value => {
                this.setState({ goodsdescription: value });
              }}
            />
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={'arrivalnotification'}
              id={this.props.id}
              autoSave
              attribute={'packages'}
              value={this.state.packages}
              onChange={value => {
                this.setState({ packages: value });
              }}
            />
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={'arrivalnotification'}
              id={this.props.id}
              autoSave
              attribute={'weigth'}
              value={this.state.weigth}
              onChange={value => {
                this.setState({ weigth: value });
              }}
            />
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={'arrivalnotification'}
              id={this.props.id}
              autoSave
              attribute={'vol'}
              value={this.state.vol}
              onChange={value => {
                this.setState({ vol: value });
              }}
            />
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={'arrivalnotification'}
              id={this.props.id}
              autoSave
              attribute={'pol'}
              onChange={value => {
                this.setState({ pol: value });
              }}
              value={this.state.pol}

            />
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={'arrivalnotification'}
              id={this.props.id}
              autoSave
              attribute={'pod'}
              onChange={value => {
                this.setState({ pod: value });
              }}
              value={this.state.pod}
            />
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={'arrivalnotification'}
              id={this.props.id}
              autoSave
              attribute={'etd'}
              filter={{ active: true }}
              value={this.state.etd}
              onChange={value => {
                this.setState({ etd: value });
              }}
            />
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={'arrivalnotification'}
              id={this.props.id}
              autoSave
              attribute={'eta'}
              value={this.state.eta}
              onChange={value => {
                this.setState({ eta: value });
              }}
            />
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={'arrivalnotification'}
              id={this.props.id}
              autoSave
              attribute={'finaldestination'}
              value={this.state.finaldestination}
              onChange={value => {
                this.setState({ finaldestination: value });
              }}
            />
          </TabPane>
          <TabPane
            tab={
              <span>
                <Icon type="car" />
                Routing Information
              </span>
            }
            key="4"
          >
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={'arrivalnotification'}
              id={this.props.id}
              autoSave
              attribute={'vessel'}
              onChange={value => {
                this.setState({ vessel: value });
              }}
              value={this.state.vessel}
            />
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={'arrivalnotification'}
              id={this.props.id}
              autoSave
              attribute={'voyage'}
              value={this.state.voyage}
              onChange={value => {
                this.setState({ voyage: value });
              }}
            />
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={'arrivalnotification'}
              id={this.props.id}
              autoSave
              attribute={'carrier'}
              filter={{ active: true }}
              value={this.state.carrier}
              onChange={value => {
                this.setState({ carrier: value });
              }}
            />
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={'arrivalnotification'}
              id={this.props.id}
              autoSave
              attribute={'atd'}
              filter={{ active: true }}
              value={this.state.atd}
              onChange={value => {
                this.setState({ atd: value });
              }}
            />
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={'arrivalnotification'}
              id={this.props.id}
              autoSave
              attribute={'ata'}
              value={this.state.ata}
              onChange={value => {
                this.setState({ ata: value });
              }}
            />
          </TabPane>

          <TabPane
            tab={<span><Icon type="box-plot" /><FormattedMessage id={"Attribute.arrivalnotification.containers"} /></span>}
            key="containers"
          >
            <List model="containers" {...belongsToProp} />
          </TabPane>

        </Tabs>
        {this.validateState()}
      </div>
    )
  }
}

export default withValues(ArrivalNotificationEdit)



// WEBPACK FOOTER //
// ./src/forms/ArrivalNotificationEdit.js